import { render } from "./history-export.vue?vue&type=template&id=728eb620&ts=true"
import script from "./history-export.ts?vue&type=script&lang=ts&external"
export * from "./history-export.ts?vue&type=script&lang=ts&external"

import "./history-export.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__